module.exports = __webpack_public_path__ + "assets/b121.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b121.png
// module id = 594
// module chunks = 0